<template>
  <div class="btn-checkout">
    <div
      :id="id"
      class="btn-checkout-popover"
      v-if="conditions && popover !== ''"
      v-b-popover.hover.top="popover"
    ></div>
    <div class="btn-wrap" v-b-hover="handle_popover">
      <vb-button
        ref="trigger_checkout"
        :vb_options="{ variant: 'info', block: fullwidth, disabled: conditions || loading }"
        @click="handle_data_emit"
      >
        <span class="btn-checkout__inner">
          <b-spinner v-if="loading" small class="btn-checkout__spinner" />
          {{ copy }}
        </span>
      </vb-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'btn-checkout',
  components: {},
  props: {
    id: {
      type: String,
    },
    conditions: {
      type: Boolean,
    },
    popover: {
      type: String,
      default: '',
    },
    fullwidth: {
      type: Boolean,
      default: true,
    },
    copy: {
      type: String,
      default: 'Vai al Checkout',
    },
    // Surfaces an inline spinner next to the label and forces the
    // button into its disabled state. Drive this from the caller's
    // in-flight promise (e.g. ancillaries.vue.commit_loading) so the
    // user sees feedback while a network round-trip is open.
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['handle_data'],
  created() {},
  methods: {
    handle_data_emit() {
      this.scroll_top();
      this.$emit('handle_data');
    },
    handle_popover(value) {
      if (value) this.$root.$emit('bv::show::popover', this.id);
      else this.$root.$emit('bv::hide::popover', this.id);
    },
    trigger() {
      this.$nextTick(() => {
        this.$refs.trigger_checkout.click();
      });
    },
  },
};
</script>

<style lang="scss">
.btn-checkout {
  position: relative;

  .btn-checkout-popover {
    position: absolute;
    z-index: 1;
    visibility: hidden;
    left: 0;
    right: 0;
    top: 0;
    &:after {
      content: '\00a0';
    }
  }
  .btn-wrap {
    position: relative;
    z-index: 2;
  }

  &__inner {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }
}
</style>
